!function(window) {

$('.fileInput').change(function(e) {
	const inputId = $(this).attr('id');
	console.log(e);
	console.log(inputId);
	$(`.fileInputLabel[for="${inputId}"] span`).text($(`#${inputId}`)[0].files[0].name);
});
}.call(window, window);